/**
 * Cliente HTTP de los disparadores del oficial (`/activa/oficial/disparadores`, 29/10/2026): mismo camino que
 * `comparativaApi` (`req()` de campana-nueva), sin `brandId` (el tenant sale del token). Del equipo: el backend se los
 * niega a una persona de un cliente. Archivo aparte de `api.ts`, que lo editan otros frentes de trabajo.
 */

import { req } from "../campana-nueva/api";
import type { Resp } from "./api";
import type { Disparador, EntradaDisparador, ListaDisparadores } from "./types.disparadores";

const B = "/activa/oficial/disparadores";
const e = encodeURIComponent;

export const disparadoresApi = {
  listar: (): Promise<Resp<ListaDisparadores>> => req("GET", B),
  crear: (x: EntradaDisparador): Promise<Resp<Disparador>> => req("POST", B, x),
  editar: (id: string, x: EntradaDisparador): Promise<Resp<Disparador>> => req("PATCH", `${B}/${e(id)}`, x),
  borrar: (id: string): Promise<Resp<{ borrado: true }>> => req("DELETE", `${B}/${e(id)}`),
  prender: (id: string): Promise<Resp<Disparador>> => req("POST", `${B}/${e(id)}/prender`, {}),
  apagar: (id: string): Promise<Resp<Disparador>> => req("POST", `${B}/${e(id)}/apagar`, {}),
  /** «Probar ahora»: arma el borrador ya (prendido o apagado). Nunca manda nada. */
  probar: (id: string): Promise<Resp<Disparador>> => req("POST", `${B}/${e(id)}/probar`, {}),
};
